import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';

import { MediaType } from '../core/types';

export class AssetJsonModel extends JsonApiModel {
  public static override readonly type = 'assets';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public name!: string;

  @Field()
  public subjectId!: string;

  @Field()
  public mediaType!: MediaType;

  @Field()
  public media_url!: string;

  @Field()
  public tags!: string[];

  @Field()
  public available!: boolean;

  @Field()
  public active!: boolean;

  @Field()
  public approval!: string;

  @Field()
  public version!: number;

  @Field()
  public sortName!: string;

  @Field({
    parse: (value) => { return value ? new Date(value) : null; },
    serialize: (value) => { return value ? value.getTime().toString() : null; }
  })
  public updated!: Date;

  @Field()
  public changedBy!: string;

  @Field()
  public copyrightInfo!: string;
}
